"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermFunctionTriple = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
/**
 * https://www.w3.org/TR/sparql12-query/#func-triple
 */
class TermFunctionTriple extends bus_function_factory_1.TermFunctionBase {
    constructor() {
        super({
            arity: 3,
            operator: utils_expression_evaluator_1.SparqlOperator.TRIPLE,
            overloads: (0, utils_expression_evaluator_1.declare)(utils_expression_evaluator_1.SparqlOperator.TRIPLE)
                .onTerm3(_ => (subject, predicate, object) => {
                if (subject.termType !== 'namedNode' && subject.termType !== 'blankNode') {
                    throw new utils_expression_evaluator_1.ExpressionError(`Subjects in triple terms must either be named nodes or blank nodes`);
                }
                if (predicate.termType !== 'namedNode') {
                    throw new utils_expression_evaluator_1.ExpressionError(`Predicates in triple terms must be named nodes`);
                }
                return new utils_expression_evaluator_1.Quad(subject, predicate, object, new utils_expression_evaluator_1.DefaultGraph());
            })
                .collect(),
        });
    }
}
exports.TermFunctionTriple = TermFunctionTriple;
//# sourceMappingURL=TermFunctionTriple.js.map